import * as React from "react";
import { ContextMenu, MenuItem, } from "react-contextmenu";
import { ThunkDispatch } from "redux-thunk";
import { dialogActions } from "../actions/dialog.actions";
import { compose } from 'redux';
import { connect, batch } from 'react-redux';
import { ColumnType } from "./PhasePlan/Column";
import { lookaheadActions } from "../actions/lookahead.actions";
import { getSelectedTagSet } from "../selectors/lookahead.selector";
import { TagType, SelectedTag } from "../models/ TagType";
import { LookaheadTag } from '../models/LookaheadTag';
import { entityActions } from '../actions/entity.actions';



const _ = require("lodash");



interface Props {
    openRipTagDialog: (tagId: string, tagType: TagType) => Promise<void>;
    openDuplicateTagDialog: (tags: Record<string, SelectedTag>, type: ColumnType) => Promise<void>;
    showBatchTagDialog: (tags: Record<string, SelectedTag>) => Promise<void>;

    openDeleteTagDialog: (tags :Record<string, SelectedTag>, type: ColumnType) => Promise<void>;
    copyTags: (tagIds: Record<string, SelectedTag>,  type: ColumnType, isMilestone?: boolean) => Promise<void>;
    duplicateTagValue: (tagIds: Record<string, SelectedTag>, type: ColumnType) => Promise<void>,
    type: ColumnType;
    selectedTags: Record<string, SelectedTag>;
    dupTagIds: {},
    dupTagType: ColumnType,
}


const TagContextMenu: React.FC<Props> = ({ openRipTagDialog, openDuplicateTagDialog, openDeleteTagDialog, showBatchTagDialog, type,  selectedTags, copyTags, duplicateTagValue }) => {
    const handleTagContextMenuClick = (e:any, data:any, target:any) => {
        const arraySelectTags:Record<string, SelectedTag> = !!selectedTags ? {...selectedTags} : {}

        const tagId = target.getAttribute('tagId')
        const tagType = target.getAttribute('tagType')
        const column = parseInt(target.getAttribute('column'),10)
        const row = parseInt(target.getAttribute('row'), 10)

        if(!!tagId && !!tagType) {
            arraySelectTags[tagId] = {
                tagCardType: tagType,
                tagType: tagType,
                position: {
                    column,
                    row
                }
            }
        }


        switch(data.action) {

            case 'Copy': 
                copyTags(arraySelectTags, type)
                break
            case 'Rip':
                if(type ===  ColumnType.PhasePlan) {
                    if(Object.keys(arraySelectTags).length > 0) {
                        openRipTagDialog(tagId, tagType) 
                    }
                }
                break; 
            case 'Duplicate':
                    openDuplicateTagDialog(arraySelectTags, type)
                break;
            case 'Delete':

                openDeleteTagDialog(arraySelectTags, type)
                
                break;
            case 'Batch': 
                showBatchTagDialog(arraySelectTags)

                break;
        }
    }

    const renderRipMenu = () => {
        if(type !== ColumnType.PhasePlan) return

        return (
            <MenuItem data={{ action: 'Rip' }} onClick={handleTagContextMenuClick} >
                Rip Tag
            </MenuItem>
        )
    }

    const renderBatchChangeMenu = () => {
        if(type !== ColumnType.Lookahead) return

        return (
            <MenuItem data={{ action: 'Batch' }} onClick={handleTagContextMenuClick} >
                Batch Change
            </MenuItem>
        )
    }

  
    const handleTagDuplicate = (e:any, data:any, target:any) => {
      
        const arraySelectTags:Record<string, SelectedTag> = !!selectedTags ? {...selectedTags} : {}
        const tagIdObj = {}
        if (!!Object.keys(arraySelectTags).length) {
            for(let tag in arraySelectTags) {
                tagIdObj[tag] = {
                    position: {
                        column: arraySelectTags[tag].position.column,
                        row: arraySelectTags[tag].position.row,
                    },
                    tagCardType: arraySelectTags[tag].tagCardType,
                    tagType: arraySelectTags[tag].tagCardType
                }
            }
            duplicateTagValue(tagIdObj, arraySelectTags[Object.keys(arraySelectTags)[0]].tagCardType)
        }
    }

    return(
        <React.Fragment>
            <ContextMenu id="tag_context_menu">
                <MenuItem data={{ action: 'Copy' }} onClick={handleTagContextMenuClick}>
                    Copy
                </MenuItem>
                {renderRipMenu()}

                <MenuItem onClick={handleTagDuplicate} >
                    Duplicate
                </MenuItem>
                {renderBatchChangeMenu()}

                <MenuItem divider />
                <MenuItem data={{ action: 'Delete' }} onClick={handleTagContextMenuClick} >
                    Delete
                </MenuItem>
            </ContextMenu>
        </React.Fragment>
    )
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return {
        openDeleteTagDialog: ( tags:Record<string, SelectedTag>, type:ColumnType, isMilestone?: boolean) => dispatch(dialogActions.showDeleteTagDialog(tags, type, isMilestone)),
        showBatchTagDialog: ( tags:Record<string, SelectedTag> ) => dispatch(dialogActions.showBatchTagDialog(tags)),
        openRipTagDialog: ( tagId:string, tagType: TagType ) => dispatch(dialogActions.showRipTagDialog(tagId, tagType)),
        copyTags: (tags: Record<string, SelectedTag>, type:ColumnType, isMilestone?: boolean) => dispatch(dialogActions.copyTags(tags, type, isMilestone)),
        duplicateTagValue: (tagIds: Record<string, SelectedTag>, type: ColumnType) => dispatch(entityActions.duplicateTag(tagIds, type)),
    }
}

const mapStateToProps = (state:any, ownProps?: any) => ({
    selectedTags: getSelectedTagSet(state, ownProps),

})

export default compose<React.ComponentClass>(
    connect(mapStateToProps, mapDispatchToProps),
    
)(TagContextMenu)




// WEBPACK FOOTER //
// ./src/components/TagContextMenu.tsx